export const CROP_PDF = 1;
export const CROP_PREVIEW = 2;
export const LOADING = 3;
